import React from 'react';
import PropTypes from 'prop-types';
import { graphql, StaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import classNames from 'classnames';

const QUERY = graphql`
  query {
    images: allFile(filter: { absolutePath: { regex: "//background/" } }) {
      edges {
        node {
          extension
          name
          relativePath
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, WEBP]
              quality: 75
              breakpoints: [300, 500, 1024, 1920]
              placeholder: BLURRED
              tracedSVGOptions: {}
              blurredOptions: {}
              jpgOptions: {}
              pngOptions: {}
              webpOptions: {}
              avifOptions: {}
            )
          }
        }
      }
    }
  }
`;

function ImageHeroComponent({
  imageFile, className, imgStyle, title, alt,
}) {
  return (
    <GatsbyImage
      image={imageFile}
      className={className}
      imgStyle={imgStyle}
      loading="eager"
      title={title}
      alt={alt}
    />
  );
}

ImageHeroComponent.propTypes = {
  imageFile: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  imgStyle: PropTypes.shape({}),
  title: PropTypes.string,
  alt: PropTypes.string,
};

ImageHeroComponent.defaultProps = {
  className: undefined,
  imgStyle: undefined,
  title: '',
  alt: '',
};

export function BackGroundComponent({
  imageFileName, headerImageExtraClass, imgStyle, title, alt,
}) {
  return (
    <StaticQuery
      query={QUERY}
      render={(query) => {
        const { images } = query;
        const { edges: data } = images;
        const img = imageFileName
          ? data.find(
            (image) => image.node.name.toLowerCase()
              === imageFileName.toLowerCase(),
          )
          : null;

        const imageFile = img ? getImage(img.node) : '';

        return (
          <ImageHeroComponent
            imageFile={imageFile}
            className={classNames('m-heroImage', headerImageExtraClass)}
            imgStyle={imgStyle}
            title={title}
            alt={alt}
          />
        );
      }}
    />
  );
}

BackGroundComponent.propTypes = {
  imageFileName: PropTypes.string.isRequired,
  headerImageExtraClass: PropTypes.string,
  imgStyle: PropTypes.shape({}),
  title: PropTypes.string,
  alt: PropTypes.string,
};

BackGroundComponent.defaultProps = {
  headerImageExtraClass: undefined,
  imgStyle: undefined,
  title: '',
  alt: '',
};

export default BackGroundComponent;
